import React from "react";
import MediaQuery from "react-responsive";
import { DesktopView } from "./DesktopView";
import { MobileView } from "./MobileView";

export function PageComments() {

    return <React.Fragment>

        {/* Desktop View */}
        <MediaQuery minDeviceWidth={991}>
            <DesktopView />
        </MediaQuery>

        {/* Mobile View */}
        <MediaQuery maxDeviceWidth={991}>
            <MobileView />
        </MediaQuery>

    </React.Fragment>
}